import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { md5 } from './../Global/md5';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { UsuarioIndexModel } from './UsuarioIndex.model';
import { ParamEstadosUsuario } from './CrearUsuario.model';




import { OpcionModel } from '../Global/Opcion.model';


@Component({
	selector : 'usuarioIndex',
	templateUrl : './UsuarioIndex.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class UsuarioIndexComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	filteredOptions: Observable<UsuarioIndexModel[]>;
	myControl = new FormControl();


	public displayedColumns = ['Usuario', 'Cédula', 'Nombres y Apellidos', 'Email', 'Estado Usuario', 'Editar'];
	public dataDataBase:OpcionesDatabase;
	public dataSource:ExampleDataSource;

	public mensaje: string = "";
	public ocultar: boolean = false;

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog){
		
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();

	}


	ngOnInit(){
		
		this.cargarTabla();

	}

	
	cargarTabla(){

		this.dataDataBase = new OpcionesDatabase();

		this._serviciosGenerales.get('usuariosSistema', {ntipoempresa : -1}).subscribe(result=>{
			for(let x in result){
				let y = result[x];
				this.dataDataBase.addOpcion(new UsuarioIndexModel(y.cusuario, y.cnumid, y.nombresApellidos, y.email, y.cdescripcion, y.cdescriprol));
			}
			this.dataSource = new ExampleDataSource(this.dataDataBase);
		},error=>{
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar los usuarios disponibles", "X");
		});
		
	}


	agregar(){
		this._router.navigate(['/CrearUsuario']);
	}
	
	editarRegistro(usuario:UsuarioIndexModel){

		this._router.navigate(['/CrearUsuario/', usuario.cusuario, usuario.cnumid]);

	}

	editarUsuarios(usuario:UsuarioIndexModel){
		this._router.navigate(['/AsignarContrato/usuario/', usuario.cusuario, usuario.cnumid]);
	}
	
	inicializarClave(usuario:UsuarioIndexModel){

		let x:ParametroInicializarClave = new ParametroInicializarClave(usuario.cusuario, md5(usuario.cnumid.trim()), usuario.cnumid);

		console.log(md5(usuario.cnumid.trim()));
		this._serviciosGenerales.post('inicializar/clave', x).subscribe(result=>{
			if(result.error != undefined && result.error == true){
				this.openSnackBar(result.mensaje, "X");
			}else{
				this.openSnackBar("Se inicializó la clave correctamente, recuerde que la nueva clave será enviada al email del usuario", "X")
			}
		}, error=>{
			console.log(error, "");
			this.openSnackBarEspecial("Ocurrió un error al momento de inicializar la clave", "X");
		});

	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
		
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}



export class ParametroInicializarClave{
	constructor( public usuario:string, public clave:string, public cnumid:string){}
}

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class OpcionesDatabase
{
	
	dataChange: BehaviorSubject<UsuarioIndexModel[]> = new BehaviorSubject<UsuarioIndexModel[]>([]);

	get data(): UsuarioIndexModel[]
	{
		return this.dataChange.value;
	}

	addOpcion(opcion:UsuarioIndexModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(opcion);
		this.dataChange.next(copiedData);
	}

}


export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		console.log(filter);
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: OpcionesDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<UsuarioIndexModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: UsuarioIndexModel) => {
				let searchStr = (item.cusuario+item.cnumid).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/AdministracionUsuarios/UsuarioIndex.component.ts